import * as actions from '../../redux/actions';
import HeroSection from '../../common/HeroSection/HeroSection';
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ContactForm4 from '../../common/contact/ContactForm4';
import CommonService from '../../../../services/commonService';
import KuposHelmet from '../../../common/KuposHelmet';
import getIcons from '../../functions/getIcons/getIcons';
import ThemeTenTitle from '../components/ThemeTenTitle';


const getLink = operator => {
  const opname = operator && operator.operator_name;
  if (opname === 'tacoha') {
    return {
      fb:
        'https://m.facebook.com/profile.php?id=312792345524109&eav=AfYgkHnJP0-n0YtyfVSxGXGDoh6o9sahtN65X43pwDTqwo51-XWG1sJNkVDjGU9t9bY&paipv=0',
      insta: 'https://www.instagram.com/tacohacl/',
    };
  } else if (opname === 'traveltur') {
    return {
      fb: 'https://www.facebook.com/busestraveltur',
      insta: 'https://www.instagram.com/travelturchile',
    };
  }
  else if (opname === 'liquine') {
    return {
      fb: 'https://www.facebook.com/busesliquine',
      insta: 'https://www.instagram.com/busesliquine',
    };
  }
  else {
    return {
      fb: 'https://www.facebook.com/busessantonio',
      insta: 'https://www.instagram.com/busessanantonio',
    };
  }
  
};

const ThemeTenContactUs = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

  const contactByArr = [
    {
      text: `${operator && operator.phone_number}`,
      image: getIcons('Support'),
    },
    {
      text: `${operator && operator.email}`,
      image: getIcons('ContactEmail'),
    },
    {
      text: `${operator && operator.address}`,
      image: getIcons('ContactLocation'),
    },
  ];

  const socialMedia = [
    {
      id: 0,
      selectedIcon: getIcons('FbInActive', operator),
      icon1: getIcons('FbInActive', operator),
      icon2: getIcons('FbActive', operator),
      link: getLink(operator).fb,
    },
    {
      id: 1,
      selectedIcon: getIcons('InstaInActive', operator),
      icon1: getIcons('InstaInActive', operator),
      icon2: getIcons('InstaActive', operator),
      link: getLink(operator).insta,
    },
  ];

  const [socialMediaArray, setSocialMediaArray] = useState(socialMedia);

  const onMouseStateChange = (method, item) => {
    let socialMediaNew = [];

    socialMediaArray.map((val, key) => {
      if (val.id === item.id) {
        socialMediaNew.push({
          ...val,
          selectedIcon: method === 'in' ? val.icon2 : val.icon1,
        });
      } else {
        socialMediaNew.push({
          ...val,
          selectedIcon: val.icon1,
        });
      }
    });
    setSocialMediaArray(socialMediaNew);
  };


  return (
    <div className="montserrat-bold">
      <KuposHelmet />
      <HeroSection
        heroImage={getIcons('ContactUsBanner', operator)}
        height={'41vh'}
        title={'Contacto'}
        description={'Home / Contacto'}
        marginTop="-50px"
      />

      <div className="new-container">
        <ThemeTenTitle title={'CONTACTO'} />
        <div className="contact-us d-flex my-5 ">
          <ContactForm4 operator={operator} showMap isSanantonio dashLine />

          <div className="contact-by w-50 d-flex justify-center align-items-start flex-column ">
            {contactByArr.map((item, key) => item.text&& (
              <div className="contact-by-item d-flex"
              >
                <img src={item.image} alt="" style={{ width: '40px' }} />
                <span
                  className="lh-1-3 "
                  style={{ fontWeight: 'bold', fontSize: '13px', width: '194px'
                 }}
                >
                  {item.text}
                </span>
              </div>
            ))}
            <div className="social-media">
              <div
                // className="font13 montserrat"
                style={{
                  color: operator.sub_footer_color && operator.sub_footer_color,
                  marginBottom: 10,
                  fontWeight: 'bold',
                  fontSize: '16px',
                }}
              >
                SÍGUENOS EN REDES SOCIALES
              </div>
              <div>
                {socialMediaArray.map(item => (
                  <a
                    href={item.link}
                    target="_blank"
                    onMouseEnter={() => onMouseStateChange('in', item)}
                    onMouseLeave={() => onMouseStateChange('out', item)}
                  >
                    <img src={item.selectedIcon} alt="" />
                  </a>
                ))}
              </div>
            </div>

            {/* {operator && operator.operator_name==='liquine'?
            <React.Fragment>
            <div
              style={{
                textAlign: 'center',
                fontSize: '13px',
                lineHeight: 1.3,
                margin: 30,
              }}
            >
              <div style={{ textAlign: 'center', marginLeft: 50 }}>
                Para reclamos, sugerencias o felicitaciones te invitamos a acceder a nuestro sistema
                de 
                <span
                style={{fontWeight:'bold'}}
                >
                  {' '}Servicio al Cliente aquí
                  </span>
              </div>
            </div>
            <a
              // href="#"
              target="_blank"
              style={{ fontSize: '15px' ,
              background: operator.color_codes && operator.color_codes.button_color,
              color:'white',
              fontWeight:'bold'
            }}
              className="andimar-btn-link less-bold-text"
            >
              Ingresa al sistema Aquí
            </a>
            <div
              style={{
                textAlign: 'center',
                fontSize: '13px',
                lineHeight: 1.3,
                margin: 30,
              }}
            >
              <div style={{ textAlign: 'center', marginLeft: 70 }}>
                En caso de problemas con compras en línea, envía tu solicitud a
                <span style={{ color: operator.theme_color2 && operator.theme_color2 }}>
                  {' '}
                  {operator && operator.email}
                {' '}
                  
                </span>
                o comunícate al
                <br />{' '}
                <span style={{ color: operator.theme_color2 && operator.theme_color2 }}>
                  {operator && operator.phone_number}
                </span>
              </div>
            </div>
            </React.Fragment>:null
            } */}

          </div>
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeTenContactUs);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/ThemeTenPages/ThemeTenContactUs.js